import React from "react";
import PropTypes from "prop-types";
import styled, { withTheme } from "styled-components";
import {
  MdKeyboardArrowLeft as BackArrowIcon,
  MdKeyboardArrowRight as ForwardArrowIcon
} from "react-icons/md";
import { Box } from "grid-styled";

import ChapterView from "./ChapterView";
import { withBible } from "../../Bible/BibleContainer";
import { withChapter } from "../ChapterContainer";

const StyledNavBox = styled(Box)`
  padding: 1rem;
  max-width: 7rem;
`;

const NavButton = styled.div`
  position: relative;
  border-radius: 2px;
  text-align: center;
  cursor: pointer;
  color: #dcdcdc;
  height: 100%;
  transition: all 0.5s;

  &:hover {
    color: ${props => props.theme.computedPrimary};
  }
  svg {
    /* provide fallback for browsers who don't support sticky */
    position: relative;
    position: sticky;
    top: 50vh;
  }
`;

const ChapterDisplayFlex = styled.div`
  display: flex;
  min-height: 100vh;
  background: ${props => props.theme.background};
  flex-direction: ${props =>
    props.theme.scriptDirection === "rtl" ? "row-reverse" : "row"};
`;

const StandardChapterLayout = props => (
  <ChapterDisplayFlex>
    <StyledNavBox flex="1">
      {props.chapter.getCurrentChapter() &&
        props.chapter.getCurrentChapter().previous && (
          <NavButton
            onClick={() => {
              props.setModeDefault();
              if (window) window.scrollTo(0, 0);
              return props.chapter.onChapterSelect({
                bibleId: props.bible.currentBibleId,
                ...props.chapter.getCurrentChapter().previous
              });
            }}
          >
            {props.theme.scriptDirection === "rtl" ? (
              <ForwardArrowIcon size={40} />
            ) : (
              <BackArrowIcon size={40} />
            )}
          </NavButton>
        )}
    </StyledNavBox>

    <Box flex="10">
      {props.chapter.getCurrentChapter() && (
        <ChapterView
          isCurrentChapter
          highlightedVerseOrgIds={props.highlightedVerseOrgIds}
          selectedVerse={props.selectedVerse}
          platformType={props.platformType}
        />
      )}
    </Box>

    <StyledNavBox flex="1">
      {props.chapter.getCurrentChapter() &&
        props.chapter.getCurrentChapter().next && (
          <NavButton
            onClick={() => {
              props.setModeDefault();
              if (window) window.scrollTo(0, 0);
              return props.chapter.onChapterSelect({
                bibleId: props.bible.currentBibleId,
                ...props.chapter.getCurrentChapter().next
              });
            }}
          >
            {props.theme.scriptDirection === "rtl" ? (
              <BackArrowIcon size={40} />
            ) : (
              <ForwardArrowIcon size={40} />
            )}
          </NavButton>
        )}
    </StyledNavBox>
  </ChapterDisplayFlex>
);

StandardChapterLayout.propTypes = {
  bible: PropTypes.shape({
    currentBibleId: PropTypes.string
  }).isRequired,
  chapter: PropTypes.shape({
    getCurrentChapter: PropTypes.func.isRequired,
    onChapterSelect: PropTypes.func.isRequired
  }).isRequired,
  highlightedVerseOrgIds: PropTypes.arrayOf(PropTypes.string),
  selectedVerse: PropTypes.node,
  theme: PropTypes.shape({
    scriptDirection: PropTypes.string.isRequired
  }).isRequired,
  platformType: PropTypes.string.isRequired
};

StandardChapterLayout.defaultProps = {
  highlightedVerseOrgIds: [],
  selectedVerse: null
};

export default withChapter(withBible(withTheme(StandardChapterLayout)));
